import { createGlobalStyle } from "styled-components";
import "../index.css";

export default createGlobalStyle`
  :root {
    /* Fonts */
    --font-heading: "Agrandir-Regular";
    --font-body: "Poppins", sans-serif;

    /* Base neutrals (soft + elegant) */
    --bg: #f6f4ef;          /* warm off-white */
    --surface: #fbf7f0;     /* slightly lifted surface */
    --ink: #1f1b16;         /* near-black with warmth */
    --muted: #5f574f;       /* secondary text */
    --border: rgba(31, 27, 22, 0.18);

    /* Brand accents (use sparingly) */
    --brand-green: #2bbd5f; /* softened from neon */
    --brand-pink: #ff77c8;  /* your pink, slightly calmer */
    --brand-red: #e23a2e;   /* red, softened */
    --brand-yellow: #f7df01;

    /* Interaction */
    --link: var(--ink);
    --link-hover: var(--brand-pink);
    --focus: rgba(255, 119, 200, 0.35);

    /* Type scale */
    --text-sm: 14px;
    --text-base: 16px;
    --text-lg: 18px;

    --radius: 12px;
    *,
*::before,
*::after {
  box-sizing: border-box;
}
  }

  /* CSS RESET (Meyer) */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    font-size: 100%;
  }

  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background: var(--bg);
    color: var(--ink);
    line-height: 1.55;
    font-family: var(--font-body);
    font-size: var(--text-base);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  /* Make images behave */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Lists */
  ol, ul { list-style: none; }

  table { border-collapse: collapse; border-spacing: 0; }

  /* Typography */
  h1, h2, h3 {
    color: var(--ink);
    letter-spacing: -0.01em;
  }

  h1 {
    font-family: var(--font-heading), sans-serif;
    font-weight: 800;
    font-size: 22px;
    line-height: 1.15;
    margin: 0 0 12px;
  }

  h2 {
    font-family: var(--font-body);
    font-weight: 700;
    font-size: 18px;
    line-height: 1.25;
    margin: 24px 0 10px;
  }

  h3 {
    font-family: var(--font-body);
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.3;
    margin: 18px 0 8px;
  }

  p, li {
    font-family: var(--font-body);
    font-weight: 400;
    font-size: var(--text-sm);
    line-height: 1.65;
    color: var(--ink);
  }

  p { margin: 0 0 14px; }

  /* Links: calm by default, brand on hover */
  a {
    color: var(--link);
    text-decoration: none;
    border-bottom: 1px solid rgba(31, 27, 22, 0.28);
    transition: color 150ms ease, border-color 150ms ease, background 150ms ease;
  }

  a:hover {
    color: var(--link-hover);
    border-bottom-color: rgba(255, 119, 200, 0.7);
  }

  /* Accessible focus */
  a:focus-visible, button:focus-visible, input:focus-visible, textarea:focus-visible {
    outline: 3px solid var(--focus);
    outline-offset: 3px;
    border-radius: 8px;
  }

  /* Optional: selection highlight feels on-brand but soft */
  ::selection {
    background: rgba(255, 119, 200, 0.25);
  }

  /* Optional: helper class for surfaces/cards */
  .surface {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
  }
`;
